import { Stack, SvgIcon } from '@mui/material';

import TourGuideIcon from 'src/assets/svg/tour_guide.svg?react';
import useGuidedTour from 'src/components/app/context/GuidedTourContext/index';

import { style } from './guidedTourIcon.styles';

const GuidedTourIcon = ({ iconId }: { iconId: string }) => {
  const { startTourAt, disabled } = useGuidedTour();
  return disabled ? null : (
    <Stack
      direction="row"
      id={iconId}
      sx={style.wrapper}
      onClick={() => startTourAt(`#${iconId}`)}
    >
      <SvgIcon component={TourGuideIcon} sx={style.icon} />
    </Stack>
  );
};

export default GuidedTourIcon;
